export const config = {
  formcarryUrl: import.meta.env.VITE_FORMCARRY_URL as string,
  recaptchaSitekey: import.meta.env.VITE_RECAPTCHA_SITEKEY as string,
} as const
